import React from "react";
import TitlePage from "../../../common/TitlePage";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Box, useMediaQuery } from "@material-ui/core";
import CircleIcon from "./../../../common/CircleIcon";
import Carousel from "react-elastic-carousel";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "100px 0",
  },
  color: {
    color: theme.palette.light.type2,
  },
  content: {
    marginTop: 65,
    width: "60%",
    margin: "auto",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      marginTop: 80,
    },
  },
  item: {
    margin: "30px 1%",
    width: "23%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& span": {
      marginTop: 10,
      fontSize: theme.fontSize.regular,
    },
    [theme.breakpoints.down("md")]: {
      minWidth: "48%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  title: {
    whiteSpace: "nowrap",
  },

  /* --- موبایل --- */
  mobileWrap: {
    width: "100%",
    marginTop: 40,
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  carouselWrap: {
    "& .rec-slide": {
      display: "flex",
      justifyContent: "center",
    },
  },
}));

export default function Service() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className={classes.root}>
      <Box textAlign="center">
        <TitlePage position="bottomCenter" padding="0px 0px">
          چرا با سامانه آنلاین کارگزاری{" "}
          <span className={classes.color}>پویان</span> ترید کنیم؟
        </TitlePage>

        {/* حالت دسکتاپ */}
        {!isMobile && (
          <Box className={classes.content}>
            {data.map((item, ind) => (
              <a key={ind} href={item.link} className={classes.item}>
                <div>
                  <CircleIcon id={item.icon} />
                  <span className={classes.title}>{item.title}</span>
                </div>
              </a>
            ))}
          </Box>
        )}

        {/* حالت موبایل – Carousel */}
        {isMobile && (
          <div className={classes.mobileWrap}>
            <div className={classes.carouselWrap}>
              <Carousel
                breakPoints={[{ width: 1, itemsToShow: 1 }]}
                enableAutoPlay
                autoPlaySpeed={2500}
                renderPagination={() => <span style={{ display: "none" }} />}
                isRTL
              >
                {data.map((item, ind) => (
                  <a key={ind} href={item.link} className={classes.item}>
                    <div>
                      <CircleIcon id={item.icon} />
                      <span className={classes.title}>{item.title}</span>
                    </div>
                  </a>
                ))}
              </Carousel>
            </div>
          </div>
        )}
      </Box>
    </div>
  );
}

const data = [
  { title: "سرعت در انجام معاملات ", icon: "kala", link: "#" },
  { title: "رابط کاربری  کاربر پسند", icon: "trades3", link: "#" },
  { title: "ارسال چندین سفارش همزمان ", icon: "system_online", link: "#" },
  { title: "نمودار تحلیل تکنیکال", icon: "train", link: "#" },
];
